<template>
  <div class="flex flex-wrap gap-y-3">
    <Field
      :rules="passwordRule"
      validate-on-input
      validate-on-change
      validate-on-blur
      name="password"
      v-slot="{ field, errors: errs }"
    >
      <TextInput
        :field="field"
        :errors="errs"
        :label="$t('newPassowrd')"
        :hint="$t('PasswordPattern')"
        input-type="password"
        class="p-0 md:odd:ps-0 md:px-3 md:even:pe-0 w-full md:w-6/12"
        label-class="w-full"
        direction="flex-col"
      />
    </Field>
    <Field
      :rules="(value) => equalPassword(values.password, value)"
      validate-on-input
      validate-on-change
      validate-on-blur
      name="password_c"
      v-slot="{ field, errors: errs }"
    >
      <TextInput
        :field="field"
        :errors="errs"
        :label="$t('confirmPassword')"
        input-type="password"
        class="p-0 md:odd:ps-0 md:px-3 md:even:pe-0 w-full md:w-6/12"
        label-class="w-full"
        direction="flex-col"
      />
    </Field>
    <Field
      :rules="requiredRule"
      validate-on-input
      validate-on-change
      validate-on-blur
      name="newUserName"
      v-slot="{ field, errors: errs }"
    >
      <TextInput
        :field="field"
        :errors="errs"
        :label="$t('newEmailOrUsername')"
        class="w-full"
        label-class="w-full"
        direction="flex-col"
      />
    </Field>
  </div>
</template>

<script setup>
import TextInput from '@/components/SimpleForm/TextInput.vue'
import { Field } from 'vee-validate'
import { useI18n } from 'vue-i18n'
import { isValidPassword } from '@/composables/useRuleHandler'

defineProps({
  values: Object
})

const i18n = useI18n()

function passwordRule(value) {
  if (!value || !isValidPassword(value)) {
    return i18n.t('PasswordPattern')
  }

  return true
}

function equalPassword(password1, password2) {
  const requiredResult = requiredRule(password2)

  if (requiredResult !== true) {
    return requiredResult
  }

  if (password1 != password2) {
    return i18n.t('PasswordNotEqual')
  }

  return true
}

function requiredRule(value) {
  if (!value || !`${value}`.trim()) {
    return i18n.t('INVALID_REQUIRED')
  }

  return true
}
</script>

<style lang="scss" scoped></style>
